// Conversion event IDs shared between the browser event and the backend request.
// Format is fixed by the backend's MetaConversionTrackingEvent: `tb_` + 32 lowercase hex.
const HEX = '0123456789abcdef';

const randomHex32 = () => {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID().replace(/-/g, '').toLowerCase();
  }
  const bytes = new Uint8Array(16);
  if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  let out = '';
  bytes.forEach((b) => {
    out += HEX[b >> 4] + HEX[b & 15];
  });
  return out;
};

export const generate = () => `tb_${randomHex32()}`;

const ID_FORMAT = /^tb_[0-9a-f]{32}$/;

// The key Ember's onboarding reads for the free-signup conversion (Ember utils/conversion-id.js freeSignupKey).
export const freeSignupKey = (userId) => `tb_conv_free_${userId}`;

// Hands the signup's event id to Ember. /auth and /app share localStorage (same origin), so Ember's
// getOrCreate() reuses this id for CompleteRegistration instead of generating its own; the browser event
// then carries the id the server already sent to Meta and the pair deduplicates (PAE-2465).
// Best effort: if storage is unavailable Ember generates its own id, as it did before.
export const shareSignupEventId = (userId, eventId) => {
  if(!userId || !ID_FORMAT.test(eventId || '')) {
    return false;
  }
  try {
    const key = freeSignupKey(userId);
    if(window.localStorage.getItem(key)) {
      return false; // never replace a record Ember already has
    }
    window.localStorage.setItem(key, JSON.stringify({ eventId, reportedAt: null }));
    return true;
  } catch (e) {
    return false;
  }
};
